import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { SkillUserDto } from './skill-user.dto';

@Api('api/agentic-cx/skill')
export class SkillDto extends DtoHasApi {
  id = 0;
  name = '';
  isActive = true;
  agentCount = 0;
  assignedUsers: SkillUserDto[] = [];
}
